import React from 'react';
import { motion } from 'framer-motion';

const BrandDefinition = () => {
  return (
    <section className="py-16 bg-vintage-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-aged-ivory p-8 md:p-12 rounded-2xl border border-warm-stone/40 shadow-editorial text-center relative overflow-hidden"
        >
          {/* Subtle accent corner */}
          <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-bl from-warm-stone/30 to-transparent rounded-tr-2xl"></div>
          
          <p className="text-xl md:text-2xl font-serif text-deep-charcoal leading-relaxed">
            Padua Weddings is a historic Spanish Revival wedding venue in the Claremont foothills of Southern California, offering ceremony and reception spaces, in-house catering, coordination support, DJ services, planning guidance, and a trusted vendor network for couples looking for an elevated but approachable wedding experience.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default BrandDefinition;